<template>
  <b-card
    no-body
    :class="
      this.$route.path.includes('dashboard') ||
      this.$route.path.includes('courses')
        ? 'h-100'
        : ''
    "
  >
    <b-card-header>
      <b-card-title>ثبت نام روزانه </b-card-title>
      <!-- datepicker -->
      <div class="d-flex flex-column  ">
        <!-- <feather-icon icon="CalendarIcon" size="16" /> -->
        <date-picker
          v-model="rangePick"
          autocomplete="on"
          id="created_at"
          range
          :editable="false"
          name="created_at"
          class="form-control flat-picker bg-transparent border-0 shadow-none p-0"
          format="jYYYY/jM/jD HH:mm"
          display-format="jYYYY/jM/jD"
        />
        <small class="text-danger mt-50" v-if="rangePick.length == 1"
          >تاریخ دوم را انتخاب کنید</small
        >
      </div>
      <!-- datepicker -->
    </b-card-header>

    <!-- chart -->
    <div v-if="loading">
      <b-skeleton
        width="95%"
        height="300px"
        style="margin: 20px auto"
      ></b-skeleton>
    </div>
    <b-card-body v-else class="d-flex justify-content-center w-100 p-0">
      <div
        v-if="this.userRegister.length == 0"
        class="align-items-center d-flex justify-content-center h-100"
      >
        <p>اطلاعاتی برای نمایش موجود نمی باشد.</p>
      </div>

      <vue-apex-charts
        style="overflow-x: auto"
        v-else
        id="revenue-report-chart"
        type="bar"
        height="320"
        :width="this.$route.path.includes('courses') ? '500' : '700'"
        :options="chartOptions"
        :series="series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BCardTitle,
  BSkeleton,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import ChartjsComponentBarChart from "./ChartjsComponentBarChart.vue";
import VueApexCharts from "vue-apexcharts";

import { $themeColors } from "@themeConfig";
import qs from "qs";
let moment = require("jalali-moment");

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    flatPickr,
    ChartjsComponentBarChart,
    BSkeleton,
  },
  data() {
    return {
      rangePick: ["1401-08-01", "1401-08-15"],
      userRegister: {},
      loading: false,
    };
  },
  watch: {
    rangePick(newValue, oldValue) {
      newValue[1] &&
        newValue.toString() !== oldValue.toString() &&
        ((this.rangePick = newValue), this.getStatistics());
    },
  },
  computed: {
    series() {
      return [
        {
          name: "ثبت نام شده ها",
          data: this.userRegister && this.userRegister.map((x) => x.count),
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          stacked: false,
          type: "bar",
          toolbar: { show: false },
        },
        grid: {
          padding: {
            left: -10,
          },
          yaxis: {
            lines: { show: true },
          },
        },
        xaxis: {
          type: "category",
          categories:
            this.userRegister &&
            this.userRegister.map((x) =>
              this.$route.path.includes("dashboard")
                ? moment(x.started_at).locale("fa").format("MM/DD")
                : moment(x.bought_at).locale("fa").format("MM/DD")
            ),
          labels: {
            show: true,
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: true,
          },
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        colors: [$themeColors.primary, $themeColors.warning, $themeColors.info],
        plotOptions: {
          bar: {
            columnWidth: "17%",
            endingShape: "rouded",
            borderRadius: 3,
          },
          distributed: true,
        },
        yaxis: {
          labels: {
            offsetX: -20,
            style: {
              colors: "#6E6B7B",
              fontSize: "0.86rem",
              fontFamily: "Montserrat",
            },
          },
        },
      };
    },
  },

  async created() {
    await this.getStatistics();
  },
  methods: {
    async getStatistics() {
      this.loading = true;
      try {
        if (this.$route.path.includes("dashboard")) {
          const params = {
            filters: {
              started_at: this.toGorgian(this.rangePick[0]),
              ended_at: this.toGorgian(this.rangePick[1]),
            },
          };
          const { data } = await this.$http.get(
            "panel/dashboard/register-user-count",
            {
              params,
              paramsSerializer: (params) => {
                return qs.stringify(params);
              },
            }
          );
          this.userRegister = data.data;
        } else {
          let type = this.$route.path.includes("semesters")
            ? "semesters"
            : this.$route.path.includes("course")
            ? "courses"
            : "";
          let filters = {
            started_at: this.toGorgian(this.rangePick[0]),
            ended_at: this.toGorgian(this.rangePick[1]),
          };
          filters[`${type}_id`] = this.$route.params.id;
          const params = {
            filters,
          };
          const { data } = await this.$http.get(
            `/panel/${type}/user-register`,
            {
              params,
              paramsSerializer: (params) => {
                return qs.stringify(params);
              },
            }
          );
          this.userRegister = data.data;
        }
      } catch (e) {}
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.vpd-input-group .vpd-icon-btn {
  margin-bottom: 0;
}
.vpd-input-group .form-control {
  border-radius: 0 5px 5px 0;
}
</style>
